import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth/AuthContext'
import { LanguageSwitcher } from './LanguageSwitcher'

/** Шапка public-страниц с гамбургером для mobile. */
export function PublicHeader() {
  const { teacher } = useAuth()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const NAV: Array<{ href: string; label: string }> = [
    { href: '#features', label: t('header.navFeatures') },
    { href: '#how', label: t('header.navHow') },
    { href: '#advantages', label: t('header.navAdvantages') },
    { href: '#pricing', label: t('header.navPricing') },
    { href: '#faq', label: t('header.navFaq') },
  ]

  return (
    <header className="bg-white/85 backdrop-blur sticky top-0 z-30 border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-3 sm:gap-6">
        <Link to="/" className="flex items-center gap-2 group flex-shrink-0">
          <img
            src="/edpad-logo.png"
            alt="EdPad"
            className="w-8 h-8 rounded transition-transform group-hover:scale-105"
          />
          <span className="font-semibold text-gray-900">{t('header.brand')}</span>
        </Link>

        <nav className="hidden md:flex items-center gap-5 text-sm text-gray-600">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} className="hover:text-primary transition-colors">
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex-1" />

        {/* Desktop auth buttons */}
        <div className="hidden md:flex items-center gap-3">
          <LanguageSwitcher className="text-sm border border-gray-200 rounded-md px-2 py-1.5 bg-white text-gray-700 cursor-pointer" />
          {teacher ? (
            <button onClick={() => navigate('/app')} className="btn-primary text-sm">
              {t('header.toCabinet')}
            </button>
          ) : (
            <>
              <Link to="/login" className="text-sm text-gray-600 hover:text-primary">
                {t('header.login')}
              </Link>
              <Link to="/login" className="btn-primary text-sm">
                {t('header.start')}
              </Link>
            </>
          )}
        </div>

        {/* Mobile burger */}
        <button
          onClick={() => setOpen((v) => !v)}
          aria-label={t('header.menu')}
          aria-expanded={open}
          className="md:hidden p-2 -mr-2 text-gray-700 hover:text-primary"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {open ? (
              <path d="M6 18L18 6M6 6l12 12" strokeLinecap="round" />
            ) : (
              <>
                <path d="M3 6h18" strokeLinecap="round" />
                <path d="M3 12h18" strokeLinecap="round" />
                <path d="M3 18h18" strokeLinecap="round" />
              </>
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-gray-200 bg-white animate-fade-in">
          <nav className="max-w-6xl mx-auto px-4 py-3 flex flex-col">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-2 text-gray-700 hover:text-primary"
              >
                {n.label}
              </a>
            ))}
            <div className="border-t border-gray-100 mt-2 pt-3">
              <LanguageSwitcher className="w-full text-sm border border-gray-200 rounded-md px-2 py-2 bg-white text-gray-700 cursor-pointer mb-2" />
            </div>
            <div className="flex gap-2">
              {teacher ? (
                <button
                  onClick={() => {
                    setOpen(false)
                    navigate('/app')
                  }}
                  className="btn-primary text-sm flex-1"
                >
                  {t('header.toCabinet')}
                </button>
              ) : (
                <>
                  <Link
                    to="/login"
                    onClick={() => setOpen(false)}
                    className="btn-outline text-sm flex-1 text-center"
                  >
                    {t('header.login')}
                  </Link>
                  <Link
                    to="/login"
                    onClick={() => setOpen(false)}
                    className="btn-primary text-sm flex-1 text-center"
                  >
                    {t('header.start')}
                  </Link>
                </>
              )}
            </div>
          </nav>
        </div>
      )}
    </header>
  )
}
